// extracted by mini-css-extract-plugin
module.exports = {"Paggination":"Paggination_Paggination__eb6a7","PageNum":"Paggination_PageNum__9CLM2","DiplayNone":"Paggination_DiplayNone__WIIIu"};